module.exports = __webpack_public_path__ + "static/media/Orleans2013.6a93681c.JPG";